import { render, staticRenderFns } from "./SearchInvoices.vue?vue&type=template&id=5224b850&scoped=true&"
import script from "./SearchInvoices.vue?vue&type=script&lang=js&"
export * from "./SearchInvoices.vue?vue&type=script&lang=js&"
import style0 from "./SearchInvoices.vue?vue&type=style&index=0&id=5224b850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224b850",
  null
  
)

export default component.exports